module.exports = __webpack_public_path__ + "static/media/check-square.b8b89e2d.svg";